<div class="table-tool-wrapper" [ngStyle]="getContainerStyles()">
  <table #tableRef [ngStyle]="getStyles()"></table>
</div>

